import React from 'react';

export default function IconSE() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#4173CD"
                d="M31.45 21.483H.552A.552.552 0 0 1 0 20.93V1.069c0-.305.247-.552.552-.552h30.896c.305 0 .552.247.552.552v19.862a.552.552 0 0 1-.552.552Z"
            />
            <path
                fill="#FFE15A"
                d="M32 9.345H13.243V.517h-3.31v8.828H.001v3.31h9.931v8.828h3.31v-8.828h18.759v-3.31Z"
            />
        </svg>
    );
}
